/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import useTask from './useTask';
import PortfolioItemViewCardWithPageOverlay from '../../portfolio-item/PortfolioItemViewCardWithPageOverlay';
import ChallengeContentWrapper from '../../Challenge/ChallengeView/ChallengeContentWrapper';
import TaskContext from './TaskContext';
import TaskHeader from './TaskHeader';
import TaskInfo from './TaskInfo';
import MobilePhaseSelect from './MobilePhaseSelect';
import TaskContentLoadingSpinner from './TaskContentLoadingSpinner';
import useMarkCoachCommentsAsReadOnLoad from './useMarkCoachCommentsAsReadOnLoad';
import TaskPerspectives from './TaskPerspectives';
import { type Task, type TaskSummary } from '@/lib/types';
import ChallengeColorBar from '../../Challenge/ChallengeView/ChallengeColorBar';
import TaskPortfolioItemContextProvider from './TaskPortfolioItemContextProvider';
import PortfolioItemFields from '../../portfolio-item/PortfolioItemFields';
import ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import PortfolioItemThumbnailHeader from '../../portfolio-item/PortfolioItemThumbnailHeader';
import ChallengeContentOuterWrapper from '../../Challenge/ChallengeView/ChallengeContentOuterWrapper';
import { PortfolioItemCloseBlockingContextProvider } from '../../portfolio-item/PortfolioItemCloseBlockingContext';

type TaskViewProps = {
  task: TaskSummary;
  onClose: () => void;
};

// TODO put TaskInfo/ChallengeInfo in afterload block?
const TaskView = ({ task: taskSummary, onClose }: TaskViewProps) => {
  const [loading, task, setTask] = useTask(taskSummary);

  useMarkCoachCommentsAsReadOnLoad(taskSummary, loading);

  // TODO verify this works properly (for mobilephaseselect)
  useEffect(() => {
    if (loading) {
      return;
    }

    setTask(task => {
      task.phase = taskSummary.phase;
    });
  }, [loading, taskSummary.phase]);

  return (
    <PortfolioItemCloseBlockingContextProvider>
      <PortfolioItemViewCardWithPageOverlay variant="task" onClose={onClose}>
        <TaskContext.Provider
          value={[task ?? (taskSummary as unknown as Task), setTask]}
        >
          <TaskPortfolioItemContextProvider>
            <ChallengeContentOuterWrapper>
              <PortfolioItemThumbnailHeader />
              <ChallengeColorBar challengeColor={taskSummary.color} />
              <ChallengeContentWrapper>
                <TaskHeader />
                <TaskInfo />
                {loading ? (
                  <TaskContentLoadingSpinner />
                ) : (
                  <>
                    <TaskPerspectives />
                    <MobilePhaseSelect />
                    <PortfolioItemFields modelType={ModelType.TASK} />
                  </>
                )}
              </ChallengeContentWrapper>
            </ChallengeContentOuterWrapper>
          </TaskPortfolioItemContextProvider>
        </TaskContext.Provider>
      </PortfolioItemViewCardWithPageOverlay>
    </PortfolioItemCloseBlockingContextProvider>
  );
};

export default TaskView;
